<script>
import {VueMaskDirective as mask} from 'v-mask'
import ClickOut from '../../../../utils/directives/clickout'
import Service from '../../../../domain/inadimplentes/services'
import UPagination from '../../../_default/components/Uloc/Pagination'
import {forEach as _forEach, debounce} from 'lodash'
import * as Status from '../../../../domain/inadimplentes/helpers/ArrematanteStatus'

export default {
  components: {
    UPagination
  },
  nome: 'inadimplentes',
  directives: {mask, ClickOut},
  data () {
    let situacaoCadastro = [
      {label: 'Pendente', value: 0, class: 'btn-default btn-danger'},
      {label: 'Excluído', value: 1, class: 'btn-default btn-success'}
    ]
    return {
      openCFilter: false,
      showFiltros: false,
      isLoading: false,
      data: null,
      paginationLimits: [25, 50, 100],
      pagination: {
        totalPages: 0,
        totalItems: 0,
        atualPage: 1,
        limit: 25
      },
      checkeds: 0,
      checkedAll: false,
      filtros: {
        busca: '',
        tipoPessoa: '',
        situacaoCadastro: [0]
      },
      filterKey: '',
      sortKey: '',
      situacaoCadastro: situacaoCadastro,
      tiposPessoa: [
        {label: 'Ambos', value: '', class: 'btn-default'},
        {label: 'Física', value: 1, class: 'btn-default'},
        {label: 'Jurídica', value: 2, class: 'btn-default'}
      ],
      sortOrders: {
        'numero': 1,
        'titulo': 1,
        'comitente': 1
      },
      prevent: {},
      dblclick: 0
    }
  },
  computed: {
    filteredData: function () {
      let sortKey = this.sortKey
      let filterKey = this.filterKey && this.filterKey.toLowerCase()
      let order = this.sortOrders[sortKey] || 1
      let data = this.data
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return data
    },
    noData () {
      let data = 'data'
      if (this[data] === null) {
        return false
      }
      if (this[data].length === 0) {
        return true
      }
      return false
    },
    getStatus () {
      return Status.Status
    }
  },
  mounted () {
    this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
  },
  activated () {
  },
  methods: {
    reload () {
      this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    loading (v) {
      this.isLoading = !!v
    },

    nextElement ({target}) {
      let index = parseInt(target.getAttribute('tabindex'))
      let next = index + 1
      document.querySelector('[tabindex="' + next + '"').focus()
    },
    open (id) {
      this.dblclick++
      if (this.dblclick === 1) {
        let self = this
        this.timer = setTimeout(function () {
          self.dblclick = 0
        }, 500)
      } else {
        clearTimeout(this.timer)
        this.$router.push({name: 'arrematantes.visualizar', params: {id: id}})
        this.dblclick = 0
      }
    },

    load (limit, page, filtros) {
      this.data = null
      this.isLoading = true
      Service.lista(limit, page, filtros)
        .then((response) => {
          this.isLoading = false
          this.data = response.data.inadimplentes
          this.pagination.atualPage = response.data.offset
          this.pagination.totalPages = response.data.totalPages
          this.pagination.totalItems = response.data.total
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },

    changePage (page) {
      console.log('Change page ', page)
      this.pagination.atualPage = page
      this.load(this.pagination.limit, page, this.montaFiltros())
    },

    checkAll (o) { /* TODO: Refact / Reuse CheckALL */
      this.$nextTick(() => {
        let ca = this.checkedAll
        let _vm = this
        console.log(ca)
        if (ca === true) {
          console.log(ca, o.length)
          this.checkeds = o.length
        } else {
          this.checkeds = 0
        }
        _forEach(o, (item, key) => {
          _vm.$set(this.data, key, Object.assign({}, this.data[key], {selected: ca})) // Analisar desempenho
          // item.selected = ca
          // console.log(item)
        })
      })
    },
    lazyCheck: function (l) {
      this.$nextTick(() => {
        if (l.selected) {
          this.checkeds += 1
        } else {
          this.checkeds += -1
        }

        if (this.checkeds < this.data.length) {
          this.checkedAll = false
        } else {
          this.checkedAll = true
        }
      })
    },

    montaFiltros () {
      let filtros = this.filtros
      let mount = ''
      // Busca
      if (filtros.busca.length > 0) {
        mount += '&busca=' + filtros.busca
      }
      console.log(filtros.tipoPessoa, String(filtros.tipoPessoa).length)
      if (String(filtros.tipoPessoa).length > 0) {
        mount += '&tipo=' + filtros.tipoPessoa
      }
      if (Array.isArray(filtros.situacaoCadastro) && filtros.situacaoCadastro.length > 0) {
        mount += '&status=' + filtros.situacaoCadastro.join(',')
      }
      return mount
    },

    pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
      let busca = this.filtros.busca
      if (this.prevent.busca === busca) {
        return
      } // previne a repetição de uma chamada de api
      this.prevent.busca = busca
      this.pagination.atualPage = 1
      this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    }, 500),
    HelperStatusTitle (v) {
      return Status.StatusTitle(v)
    },
    exportMails () {
      Service.exportMails().then((response) => {
        console.log(response)
        let filename = response.headers.filename || 'inadimplentes_contatos.xls'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
    },
    cobrar (id) {
      Service.cobrar(id).then((response) => {
        console.log(response)
        alert('Cobrança enviada com sucesso!')
        this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      })
        .catch(error => {
          console.log(error)
          alert('Falha ao tentar cobrar inadimplemnte.')
        })
    }
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Inadimplentes <span class="badge">{{pagination.totalItems}}</span>
                  </h1>
                  <small class="text-muted">
                    <!--<ordenar-arrematante></ordenar-leilao>-->
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">

                    <!--<router-link :to="{name: 'arrematante.novo'}" tag="button" class="btn btn-default btn-sm "><i
                      class="fa fa-plus"></i>
                      Novo Leilão
                    </router-link>-->
                    <!--<button  href="#contacts" @click="$router.push({name: 'inadimplentes.estatisticas'})" class="btn btn-default btn-sm m-l-xs "><i
                      class="glyphicon glyphicon-dashboard"></i> Estastísticas de Cadastro
                    </button>

                    <button  href="#contacts" @click="$router.push({name: 'inadimplentes.aprovacao'})" class="btn btn-default btn-sm m-l-xs "><i
                      class="glyphicon glyphicon-import"></i> Painel de Aprovação
                    </button>-->

                  </div>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-7 m-b-xs">
                  <!--<button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Iniciar Campanha de Marketing
                  </button>
                  <div class="btn-group dropdown">
                    <button type="button" class="btn btn-sm btn-default" disabled data-toggle="dropdown">
                      Exportar
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                    </ul>
                  </div>
                  <button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Deletar
                  </button>
                  <router-link tag="button" :to="{name: 'inadimplentes.relatorios.basico'}" type="button" class="btn btn-sm btn-default">
                    Relatórios
                  </router-link>
                  <button @click="exportMails" tag="button" type="button" class="btn btn-sm btn-default">
                    <i class="fa fa-envelope"></i> Exportar Emails
                  </button>-->
                </div>
                <div class="col-sm-5">
                  <div class="input-group">
                    <div class="input-group-btn">
                      <a @click="showFiltros = !showFiltros" class="btn btn-sm btn-default"><span
                        class="m-r-xs font-bold">{{ !showFiltros ? '+' : '-' }}</span>Filtros</a>
                    </div>
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                    <span class="input-group-btn">
                                <button class="btn btn-sm btn-default" type="button">Buscar</button>
                            </span>
                  </div>
                </div>
              </div>
              <!--<div class="wrapper m-b-n m-t-n text-right">
                <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                              :total="pagination.totalPages"></u-pagination>
              </div>-->
              <div class="hidden-print">
                <div class="panel wrapper-lg m-t-n" v-show="showFiltros">
                  <div class="r-table-content_ m-t-n">
                    <div class="row">
                      <div class="col-sm-6">
                        <div>Tipo de Pessoa:</div>
                        <u-button-group @change="reload()" v-model="filtros.tipoPessoa"
                                        :options="tiposPessoa"></u-button-group>
                      </div>
                      <div class="col-sm-6">
                        <div>Situação:</div>
                        <u-button-group @change="reload()" :multiSelect="true" v-model="filtros.situacaoCadastro"
                                        :options="situacaoCadastro"></u-button-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-xs font-thin text-light m-l-lg">Duplo clique para abrir o arrematante</div>
              <div class="table-responsive">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th style="width:20px;">
                      <label class="i-checks m-b-none">
                        <input type="checkbox" @change="checkAll(data)" v-model="checkedAll" tabindex="0"
                               aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </th>
                    <th>ID</th>
                    <th>Nome</th>
                    <th>Apelido</th>
                    <th>Documento</th>
                    <th>Inclusão</th>
                    <th>Exclusão</th>
                    <th>Cobranças</th>
                    <th>Situação</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <!-- ngRepeat: pessoa in pessoas| limitTo: 10 -->
                  <tr @click="open(arrematante.arrematante.id)" v-for="arrematante in filteredData">
                    <td class="v-middle"><label
                      class="i-checks m-b-none"><input v-on:click.stop="lazyCheck(arrematante)" type="checkbox"
                                                       name="post[]"
                                                       v-model="arrematante.selected"
                                                       tabindex="0" aria-checked="false"
                                                       aria-invalid="false"><i></i></label></td>
                    <td role="button" tabindex="0">{{ arrematante.arrematante.id }}</td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">{{ arrematante.arrematante.pessoa.nome }}</a>
                      <!--<div>-->
                      <!--<small class="text-muted  block text-ellipsis ">126 lotes</small>-->
                      <!--</div>-->
                    </td>
                    <td role="button" tabindex="0">
                      {{ arrematante.arrematante.apelido }}
                    </td>
                    <td role="button" tabindex="0">
                      <div v-if="arrematante.arrematante.pessoa.tipo === 1">{{ arrematante.arrematante.pessoa.cpf |
                        formataCpf }} <i
                          class="font-thin">PF</i></div>
                      <div v-else>{{ arrematante.arrematante.pessoa.cnpj | formataCnpj }} <i class="font-thin">PJ</i>
                      </div>
                    </td>
                    <td role="button" tabindex="0">
                      {{ moment(arrematante.dataInclusao.date).format('L LTS') }}
                    </td>
                    <td role="button" tabindex="0">
                      {{ arrematante.dataExclusao && moment(arrematante.dataExclusao.date).format('L LTS') }}
                    </td>
                    <td role="button" tabindex="0">
                      {{ arrematante.cobrancas }}
                      <button @click="cobrar(arrematante.id)" class="btn btn-primary btn-xs">Cobrar</button>
                    </td>
                    <td role="button" tabindex="0">
                      <div v-if="getStatus[arrematante.status]" :class="'text-' + getStatus[arrematante.status].class">
                        <i class="fa fa-bell" v-if="arrematante.status === 0"></i>
                        <i class="fa fa-check" v-if="arrematante.status === 1"></i>
                        {{ getStatus[arrematante.status].titulo }}
                      </div>
                    </td>
                  </tr><!-- end ngRepeat: pessoa in pessoas| limitTo: 10 -->

                  <tr v-if="!filteredData || filteredData.length === 0">
                    <td colspan="6">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-2 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{
                      pagination.totalPages
                      }}
                    </small>
                  </div>
                  <div class="col-sm-6 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                  :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>


    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Inadimplentes.vue?08a19768